<template>
  <textarea
    class="w-full border px-3 py-2 font-mono text-sm focus:outline-none resize-y bg-gray-200 whitespace-pre-wrap border-gray-300 text-gray-800 dark:text-dark-text dark:border-dark-200 dark:bg-dark-400"
    :readonly="!isEditable"
    :style="`height: ${height}px; border-radius: 0.5rem`"
    :value="value"
    wrap="off"
    @input="changeText"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      required: false,
      default: 200
    },
    isEditable: {
      type: Boolean,
      required: true
    },
    onChange: {
      type: Function,
      required: false
    }
  },
  setup(props) {
    const changeText = (e: Event) => {
      const target = e.target as HTMLTextAreaElement
      if (props.onChange) {
        props.onChange(target.value)
      }
    }

    return {
      changeText
    }
  }
})
</script>

<style>
.resize-textarea::-webkit-resizer {
  border: 2px solid black;
  background: red;
  box-shadow: 0 0 5px 5px blue;
  outline: 2px solid yellow;
}
</style>
